import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import { memberPortal } from "../member-portal";
import { bookingFormCommon } from "../c005-bookingform-common";
import { adobeDataLayerWrapper } from "../adobeDataLayerMethod";


export class travellerpass {
	private addForm: any = $('#fly-pass-booking---container');
	$scope: any = $('#fly-pass-booking---container');
	private memberBase: any = new memberPortal(); $error: Array<any>;
	private bookingformcommon = new bookingFormCommon();
	private $selectFrom: any = null;
	private $selectTo: any = null;
	private selectedFrom: any = null;
	private selectedTo: any = null;
	private initialLocationList: any = [];
	private destinationList: any = [];
	private selectedTravelPass: any = [];

	initSelectizeInputs(travelLocationList: any, type: any): any {
		let _self = this;
        let bcommon = _self.bookingformcommon;
		bcommon.preloader();
		if (type === 'travelpass') {
			for (let key in travelLocationList[type]) {
				if (travelLocationList[type][key] !== undefined) {
					if (key === 'online') {						
						for (let key1 in travelLocationList[type][key]) {
							_self.initialLocationList = _self.processFromLocations(travelLocationList[type][key]);
						}
					}
				}
			}
		}
		_self.$selectTo = $('#toLocationGroup').selectize({
			options: _self.initialLocationList,
			optgroups: [
				{value: 'location', label: 'With Malaysia Airlines'}
			],
			optgroupField: 'class',
			valueField: 'value',
			labelField: 'name',
			render: {
				optgroup_header: function() {
					return "<optgroup label='With Malaysia Airlines'></optgroup>";
				}
			},
			onChange: function(value: any) {
				_self.selectedTo = value;
				let destArr = _self.processDestination(_self.destinationList);
				let destObj = _self.fetchSelectedObj(value, destArr);
				if(destObj.length > 0) {
					_self.selectedTravelPass = destObj[0].travelpass;
				}
			}
		});
		let selectTo = _self.$selectTo[0].selectize;
		_self.$selectFrom = $('#fromLocationGroup').selectize({
			options: _self.initialLocationList,
			optgroups: [
				{value: 'location', label: 'With Malaysia Airlines'}
			],
			optgroupField: 'class',
			valueField: 'value',
			labelField: 'name',
			render: {
				optgroup_header: function() {
					return "<optgroup label='With Malaysia Airlines'></optgroup>";
				}
			},
			onChange: function(value: any) {
				_self.selectedFrom = value;
				_self.destinationList = _self.fetchSelectedObj(value, _self.initialLocationList);
				selectTo.clearOptions();
				let destArr = _self.processDestination(_self.destinationList);
				if(destArr.length > 0) {
					selectTo.removeOption('Option '+ destArr.length);
					selectTo.addOption(destArr);
					selectTo.open();
				}
			}
		});
		$('#onSearchFlyPass').click(function(event: any) {
			event.preventDefault();
			adobeDataLayer.push('click', {
				'pageName': '',
				'pageType': 'Enrich Fly Pass',
				'clickName': 'click:btn-click:search-fly-pass',
				'componentType': 'btn',
				'componentName': '',
				'componentID': '',
				'attributes': []
			});
			if(_self.selectedFrom === null) {
				$('.from-location-error').removeClass('hideclass');
				$('.from-location-error').addClass('showclass');
			} else if(_self.selectedTo === null) {
				$('.to-location-error').removeClass('hideclass');
				$('.to-location-error').addClass('showclass');
			} else {
				$('.from-location-error').removeClass('showclass');
				$('.from-location-error').addClass('hideclass');
				$('.to-location-error').removeClass('showclass');
				$('.to-location-error').addClass('hideclass');
				// show recommended fly passes
				$('#travelPassCode').html(_self.selectedTravelPass);
				$('.recommended-fly-passes').removeClass('hideclass');
				$('.recommended-fly-passes').addClass('showclass');
			}
		});
	}
	processDestination(destination: any) {
		if(destination.length == 0) {
			return [];
		}
		if(destination[0].destinations.online.length == 0) {
			return [];
		}
		let destObj = [];
		for (let key in destination[0].destinations.online) {
			if(destination[0].destinations.online[key] !== undefined) {
				let loc = destination[0].destinations.online[key];
				for (let key1 in loc) {
					destObj.push({
						class: loc[key1].airportCode,
						value: loc[key1].airportName,
						name: loc[key1].airportName,
						travelpass: loc[key1].productName ? loc[key1].productName : null
					})
				}
			}
		}
		return destObj;
	}
	fetchSelectedObj(value: any, list:any) {
		let loc = list.filter((location:any) =>{
			if(location.value == value) {
				return location;
			}
		})
		return loc.length > 0 ? loc : [];
	}
	processFromLocations(locations: any) {
		let completedList = locations;
		let processList = [];
		for (let key in locations) {
			if (locations[key] !== undefined) {
				processList.push({
					class: locations[key].source.airportCode,
					value: locations[key].source.airportName,
					name: locations[key].source.airportName,
					destinations: locations[key].destinations
				});
			}
		}
		return processList;
	}
}

let scope: Element = document.querySelector('#fly-pass-booking---container');

if (scope) {
	try {
		let travelpass = new travellerpass();
		var adobeDataLayer = new adobeDataLayerWrapper();
		let travelpasscodeurl: string = $('[data-get-travel-pass-airport-complete-list]').attr('data-get-travel-pass-airport-complete-list');
		let travelLocationList = [];
		$.ajax({
			type: 'GET',
			url: travelpasscodeurl,
			// data: data,
			async: false,
			success: function (travelPassData: any) {
				travelLocationList = travelPassData;
				travelpass.initSelectizeInputs(travelLocationList, 'travelpass');
			},
			error: function (msg: any) {
				console.log(msg);
			}
		});
	} catch (e) { console.error(e); }
}